import { render, staticRenderFns } from "./Goodsclass.vue?vue&type=template&id=54fcfde2&scoped=true&"
import script from "./Goodsclass.vue?vue&type=script&lang=js&"
export * from "./Goodsclass.vue?vue&type=script&lang=js&"
import style0 from "./Goodsclass.vue?vue&type=style&index=0&id=54fcfde2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fcfde2",
  null
  
)

export default component.exports